import styles from './DatasDePagamento.module.scss';
import { useEffect, useState } from "react";
import { IPedido } from "../../../interfaces/pedido.interface";
import useFetchCompradores from '../../../hooks/compradores/useFetchCompradores';
import { IComprador } from '../../../interfaces/comprador.interface';

export default function DatasDePagamento({ pedido }: { pedido: IPedido }) {
    const [datas, setDatas] = useState<Date[]>([]);
    const { compradores } = useFetchCompradores();
    const [comprador, setComprador] = useState<IComprador | undefined>(undefined);

    useEffect(() => {
        const datasDePagamento: Date[] = pedido.datasPagamento.map(data => new Date(data));
        setDatas(datasDePagamento);
        setComprador(compradores.find((c) => c.id === pedido.compradorId));
    }, [pedido, compradores]);

    return (
        <div>
            <div className={styles.container}>
                <div className={styles.datas}>
                    <h4>DATAS DE VENCIMENTO</h4>
                    <div>
                        {datas.map((data, index) => (
                            <div key={index}>
                                <h3>{index + 1}º PGTO</h3>
                                <p>{data.toLocaleDateString()}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className={styles.containerTipoNota}>
                    <div className={styles.tipoNota}>
                        <h4>TIPO DE NOTA</h4>
                        <p>{pedido.tipoNota}</p>
                    </div>

                    <div className={styles.dataEntrega}>
                        <h4>DATA DA ENTREGA</h4>
                        <p>{pedido.dataEntrega ? new Date(pedido.dataEntrega).toLocaleString() : ''}</p>
                    </div>
                </div>
            </div>

            <div className={styles.assinaturas}>
                <div>
                    <h3>{comprador?.razaoSocial.toUpperCase()}</h3>
                </div>

                <div>
                    <h3>IARA LUIZA CONCEIÇÃO CAVALCANTE <br /> REPRESENTANTE LEGAL</h3>
                </div>

                {/* <div>
                    <h3>Elizangela Conceição Cavalcante <br /> CONFERENTE</h3>
                </div> */}
            </div>
        </div>
    );
}
